<div>
  <div style="margin-top: 5px; margin-right: 8px">
    <mat-icon>message</mat-icon>
  </div>
  <div>
    <span class="text1">Select a chat to start messaging</span>
    <span class="text2">Messages sent will appear here</span>
  </div>
</div>
